import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getAllUsersAPI } from './api';

const ALL_USERS = 'allUsers';

export function useAllUsers() {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isError, refetch } = useQuery(
    [ALL_USERS, tenantId],
    () => getAllUsersAPI(),
  );

  return {
    users: data || [],
    isLoading,
    isError,
    refetch,
  };
}
